import React from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import _Button from "../../../generic/_Button";
import Icon from "../../../Icon";
const _ModalPreview = (props) => {
  const { visible, onClose, title, data } = props;
  return (
    <div>
      {" "}
      <Modal show={visible} onHide={onClose} size="lg" centered>
        <Modal.Header closeButton>
          <div className="text-xl font-semibold text-gray-600 flex items-center gap-1">
            {" "}
            <Icon icon="visibility" size={26} className={"text-blue-600"} />
            {title}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="flex flex-col overflow-auto space-y-2">
            <div className="rounded-lg border bg-gray-50 px-2 py-2 shadow-md">
              <div className="text-lg font-semibold text-gray-600">ASUNTO</div>

              <div className="text-md font-semibold text-gray-600">
                {data.subject}
              </div>
            </div>
            <div className="rounded-lg border bg-gray-50 px-2 py-2 shadow-md">
              <div className="text-lg font-semibold text-gray-600">Mensaje</div>
              <div
                className="text-[12px]"
                dangerouslySetInnerHTML={{
                  __html: data.message,
                }}
              ></div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <_Button title="Cerrar" onClick={onClose} style="primary" />
        </Modal.Footer>
      </Modal>
    </div>
  );
};
_ModalPreview.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onAction: PropTypes.func,
  isLoading: PropTypes.bool,
  data: PropTypes.object,
};
export default _ModalPreview;
